import React from "react";
import Banner from "../../components/Banner";
import Footer from "../../components/Footer";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Select from "react-select";
import Spinner from "../../components/Spinner";
import "../../css/Wireframe.css";

const API = localStorage.getItem("assethost");

// CompanyType options, flattened array
const COMPANY_TYPES = [
  { value: "CORPORATE", label: "Corporate" },
  { value: "TRADER_CHANNEL_PARTNER", label: "Trader/Channel Partner" },
  { value: "INSURANCE", label: "Insurance" },
  { value: "INDIVIDUAL", label: "Individual" },
  { value: "OTHER", label: "Other" },
];

export default class ApiKeySettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // Table data
      apiKeys: [],
      // Form state - flattened
      apiKeyId: "",
      apiKeyCompanyId: 0,
      apiKeyRole: "CORPORATE",
      // Pagination
      page: 0,
      size: 10,
      totalPages: 1,
      // UI state
      loading: true,valid:false,
      msg: "",
      toastColor: "",
      editing: false,
      errors: {},
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
    this.handlePreviousPage = this.handlePreviousPage.bind(this);
    this.handleNextPage = this.handleNextPage.bind(this);
    this.validate = this.validate.bind(this);
    this.fetchApiKeys = this.fetchApiKeys.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
        window.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      return;
    }
    this.loadData(token);
  }

  loadData(token) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    this.fetchApiKeys(0, 10, token);
  }

  fetchApiKeys(page, size, token) {
    axios
      .get(API + "/settings/getapikeybycompanyid/1", {
        params: { page, size },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        let keys = [];
        let totalPages = 1;
        if (response.data && Array.isArray(response.data)) {
          keys = response.data;
        } else if (
          response.data &&
          response.data.content &&
          Array.isArray(response.data.content)
        ) {
          keys = response.data.content;
          totalPages = response.data.totalPages || 1;
        } else {
          keys = [];
        }
        this.setState({
          apiKeys: keys,
          page,
          totalPages,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          apiKeys: [],
          totalPages: 1,
          loading: false,
          msg: error?.response?.data?.message || "Failed to load API keys.",
          toastColor: "danger",
        });
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }

  handleSelect(name, value) {
    this.setState({ [name]: value }, this.validate);
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (this.state.editing) {
      // Form validation - explicit ifs
      if (!s.apiKeyId || !s.apiKeyId.trim()) {
        errors.apiKeyId = "API Key ID is required";
        valid = false;
      }
      if (!s.apiKeyCompanyId || s.apiKeyCompanyId === 0) {
        errors.apiKeyCompanyId = "Company ID is required";
        valid = false;
      }
      if (!s.apiKeyRole || !s.apiKeyRole.trim()) {
        errors.apiKeyRole = "Role is required";
        valid = false;
      }
    }
    this.setState({ errors, valid });
    return valid;
  }

  handleSave(e) {
    if (e) e.preventDefault();
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
        window.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      return;
    }
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });

    const request = {
      id: this.state.apiKeyId,
      companyId: this.state.apiKeyCompanyId,
      role: this.state.apiKeyRole,
    };

    const self = this;
    axios
      .post(
        API +
          "/settings/apikeysave/" +
          sessionStorage.getItem("companyProfileId"),
        request,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.success) {
          self.setState({
            msg: "API key saved successfully!",
            toastColor: "success",
            loading: false,
          });
          // Reset form
          self.setState({
            apiKeyId: "",
            apiKeyCompanyId: 0,
            apiKeyRole: "CORPORATE",
          });
          self.setState({ editing: false });
          // Refetch data
          self.fetchApiKeys(self.state.page, self.state.size, token);
        } else {
          self.setState({
            msg: response.data.message || "Failed to save API key.",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to save API key. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  handleEdit(apiKeyId = "", apiKeyCompanyId = 0, apiKeyRole = "CORPORATE") {
    this.setState(
      {
        editing: true,
        apiKeyId: apiKeyId,
        apiKeyCompanyId: apiKeyCompanyId,
        apiKeyRole: apiKeyRole,
      },
      this.validate
    );
  }

  handleCancelEdit() {
    this.setState({
      apiKeyId: "",
      apiKeyCompanyId: 0,
      apiKeyRole: "CORPORATE",
      editing: false,
      errors: {},
    });
  }

  handlePreviousPage() {
    if (this.state.page > 0) {
      const token = sessionStorage.getItem("token");
      this.fetchApiKeys(this.state.page - 1, this.state.size, token);
    }
  }

  handleNextPage() {
    if (this.state.page + 1 < this.state.totalPages) {
      const token = sessionStorage.getItem("token");
      this.fetchApiKeys(this.state.page + 1, this.state.size, token);
    }
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-h-screen h-dvh flex justify-between bg-white">
        <Sidebar />
        <div className="min-h-screen w-[85%] flex flex-col">
          <Banner title="API Key Settings" />
          {divMsg}
          <div className="w-full grow px-5 h-[60%]">
            {s.editing ? (
              // Edit/Add Form
              <form
                className="flex flex-col items-center w-full mt-2 pt-3 pb-2 h-full overflow-y-auto"
                autoComplete="off"
                onSubmit={this.handleSave}
              >
                <div className="grid grid-cols-2 gap-x-8 gap-y-4 max-w-5xl mx-auto">
                  <div className="input-group">
                    <label className="input-group-text">API Key ID</label>
                    <input
                      name="apiKeyId"
                      className={`form-control ${
                        s.errors.apiKeyId ? " !border-red-500" : ""
                      }`}
                      value={s.apiKeyId}
                      onChange={this.handleChange}
                      required
                      autoFocus
                    />
                    {s.errors.apiKeyId && (
                      <span className="input-group-error">
                        {s.errors.apiKeyId}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Company ID</label>
                    <input
                      name="apiKeyCompanyId"
                      type="number"
                      className={`form-control ${
                        s.errors.apiKeyCompanyId ? " !border-red-500" : ""
                      }`}
                      value={s.apiKeyCompanyId}
                      onChange={this.handleChange}
                      required
                    />
                    {s.errors.apiKeyCompanyId && (
                      <span className="input-group-error">
                        {s.errors.apiKeyCompanyId}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Role</label>
                    <Select
                      name="apiKeyRole"
                      value={COMPANY_TYPES.find(
                        (type) => type.value === s.apiKeyRole
                      )}
                      onChange={(e) =>
                        this.handleSelect(
                          "apiKeyRole",
                          e ? e.value : "CORPORATE"
                        )
                      }
                      className={`form-control ${
                        s.errors.apiKeyRole ? " !border-red-500" : ""
                      }`}
                      required
                      options={COMPANY_TYPES}
                    />
                    {s.errors.apiKeyRole && (
                      <span className="input-group-error">
                        {s.errors.apiKeyRole}
                      </span>
                    )}
                  </div>
                </div>
                <div className="flex justify-center gap-8 mt-4">
                  {s.valid && (
                    <button type="submit" className="btn btn-success">
                      Generate API Key
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={this.handleCancelEdit}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            ) : (
              // Table View
              <div className="h-full w-full">
                <div className="flex gap-2 mb-2 items-baseline justify-between">
                  <h3 className="font-bold">Configured API Keys</h3>
                  <button
                    className="hover:font-bold flex gap-1 group"
                    onClick={() => this.handleEdit("", 0, "")}
                  >
                    <i
                      className="bi bi-plus-circle group-hover:scale-105"
                      style={{ color: "black" }}
                    ></i>
                    Add
                  </button>
                </div>
                {s.apiKeys.length === 0 ? (
                  <div className="text-gray-500">No API keys found.</div>
                ) : (
                  <div className="overflow-x-auto w-full border h-[93%] relative overflow-y-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50 sticky top-0">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            ID
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Company ID
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Role
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {s.apiKeys.map((key, index) => (
                          <tr key={index} className="hover:bg-gray-50">
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {key.id}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {key.companyId}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {key.role}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                              <button
                                className="btn btn-success"
                                onClick={() =>
                                  this.handleEdit(
                                    key.apiKeyId,
                                    key.apiKeyCompanyId,
                                    key.apiKeyRole
                                  )
                                }
                              >
                                Edit
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {s.totalPages > 1 && (
                  <div className="flex justify-center items-center gap-2 mt-4">
                    <button
                      className="btn btn-outline"
                      disabled={s.page === 0}
                      onClick={this.handlePreviousPage}
                    >
                      Previous
                    </button>
                    <span>
                      Page {s.page + 1} of {s.totalPages}
                    </span>
                    <button
                      className="btn btn-outline"
                      disabled={s.page + 1 >= s.totalPages}
                      onClick={this.handleNextPage}
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}
